import { Swiper as SwiperCore, SwiperSlide } from "swiper/react";
import "./Swiper.css";

import imagen1 from "../../assets/carrusel1.jpg";
import imagen2 from "../../assets/carrusel2.jpg";
import imagen3 from "../../assets/carrusel3.jpg";

import "swiper/css";
import "swiper/css/effect-fade"; // 👈 IMPORTANTE

import { Autoplay, EffectFade } from "swiper/modules";

const Swiper = () => {
  return (
    <SwiperCore
      modules={[Autoplay, EffectFade]}
      effect="fade" // 👈 clave
      fadeEffect={{ crossFade: true }} // 👈 transición más suave
      spaceBetween={20}
      slidesPerView={1}
      loop={true}
      speed={1200} // 👈 duración de la transición (más alto = más suave)
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
    >
      <SwiperSlide>
        <img src={imagen1} alt="img1" className="slide" />
      </SwiperSlide>

      <SwiperSlide>
        <img src={imagen2} alt="img2" className="slide" />
      </SwiperSlide>

      <SwiperSlide>
        <img src={imagen3} alt="img3" className="slide" />
      </SwiperSlide>
    </SwiperCore>
  );
};

export default Swiper;
